var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SaveModal',_vm._b({attrs:{"color":"success","icon":"mdi-plus","maxWidth":_vm.maxWidth,"button":"Vytvoriť","setTitle":_vm.setTitle,"setItemForm":_vm.setItemForm,"saveData":_vm.createData},on:{"onSave":(response) => _vm.$emit('onCreate', response)},scopedSlots:_vm._u([{key:"default",fn:function({
        errors,
        ItemForm
      }){return [_vm._t("default",null,{"errors":errors,"ItemForm":ItemForm})]}}],null,true)},'SaveModal',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }